import { Button } from "primereact/button";

interface WizardStepFinishProps {
  wifiSSID: string;
  onFinish: () => void;
}

export function WizardStepFinish({
  wifiSSID,
  onFinish,
}: WizardStepFinishProps) {
  return (
    <div className="p-fluid">
      <div className="p-field">
        <h3>Configuration Complete</h3>
        <p>The device has been successfully configured!</p>
        <p>
          The Lifeguard is now connected to the WiFi network{" "}
          <strong>{wifiSSID}</strong> and linked to your account.
        </p>
        <p>
          You can close this wizard, and the device will appear in the list of
          available devices.
        </p>
        <div style={{ marginTop: "24px" }}>
          <Button
            label="Finish"
            icon="pi pi-check"
            onClick={onFinish}
            className="p-button-success"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
